
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/native-delivery/emails",
      function () {
        return require("private-next-pages/native-delivery/emails.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/native-delivery/emails"])
      });
    }
  